import * as ActionTypes from '../constants';
import { baseUrl, } from '../index';
import AsyncStorage from '@react-native-community/async-storage';
import axios from 'axios'; 
import { getUserToken } from './../getUserToken';




export default function (state = {}, action) { 
    switch (action.type) {
      case ActionTypes.REQUEST_TEST:
        return {
          ...state,
          loading: true,
          requestedTestId: action.requestedTestId,
          error: false,
          errorInfo: null,
        };
      case ActionTypes.RECEIVED_TEST: 
          return {
              ...state,
              loading: false, 
              test: action.test,
              testDuration: action.duration,
              testId: action.testId,
              activeQuestion:0,
              questionsInfo:[],
              totalResponse: action.data,
              passages: action.passages,
              tempTimeStamp: null,
              timeSpent: {}                 
          }
      case ActionTypes.SPEND_TIME_FOR_EACH_QUESTION: 
          return {
            ...state,
            tempTimeStamp: action.tempTimeStamp,
            timeSpent: action.timeSpent
          }
      case ActionTypes.INITIAL_TIME_STAMP: 
          return {
            ...state,
            tempTimeStamp: Date.now()
          }
      case ActionTypes.ERROR_TEST: 
          return {
            ...state,
            loading: false,
            error: true,
            errorInfo: action.error
          }
      case ActionTypes.SELECTED_ANSWERS: 
          return {
            ...state,
            selectedAnswers: action.answer,           
          }
      case ActionTypes.CHANGE_QUESTION:
          return {
            ...state,
            activeQuestion:action.qustionsNo,
            touched: true
          }
      case ActionTypes.MARKED_QUESTION:
          return {
            ...state,
            questionsInfo:action.questions,          
          }
      case ActionTypes.CLEAR_TEST:
          return {
              
          }
      default:
        return state;
    }
  };
  

 


const dispatchRequestTest = test => ({
    type: ActionTypes.REQUEST_TEST,
    requestedTestId: test   
})

const dispatchReceviedTest = (test, duration, test_id, data, passages) => ({
    type: ActionTypes.RECEIVED_TEST,
    test,
    duration,
    testId: test_id,
    data,
    passages
})

const dispatchErrorTest = (e) => ({
    type: ActionTypes.ERROR_TEST,
    error:e
})

const dispatchSelectedAnswers = (ans, qi) => ({
    type: ActionTypes.SELECTED_ANSWERS,
    answer: ans,
    quistionsInfo: qi
})

const dispatchMarkedQuestions = questions => ({
    type: ActionTypes.MARKED_QUESTION,
    questions
})

const dispatchChangeQuestion = qNo => 
{
    console.log(qNo);
    return({
        type: ActionTypes.CHANGE_QUESTION,
        qustionsNo:qNo
    })
}
const dispatchClearTest = () => ({
    type: ActionTypes.CLEAR_TEST,    
})

const dispatchSpentTime = (tempTimeStamp, timeSpent) => ({
    type: ActionTypes.SPEND_TIME_FOR_EACH_QUESTION,
    tempTimeStamp,
    timeSpent
})

const dispatchInitialTimeStamp = () => ({
    type: ActionTypes.INITIAL_TIME_STAMP,
})

export const clearTest = () => dispatchClearTest();

 
export const setInitialStartTimeStamp = () => dispatch => {
    dispatch(dispatchInitialTimeStamp());
}


export const timeSpend = (qId) => (dispatch, getState) => {
    const state = getState();
    const { testInfo={} } = state || {};
    let {
        tempTimeStamp,
        timeSpent = {}
    } = testInfo;
 
    let now = Date.now();
    if(!tempTimeStamp) tempTimeStamp = now;
    const remain = now - tempTimeStamp;
    timeSpent[qId] = timeSpent[qId] ? timeSpent[qId] + remain : remain;
    tempTimeStamp = now;

    const _timeSpent = {...timeSpent};   
    dispatch(dispatchSpentTime(tempTimeStamp, _timeSpent))
}

export function changeQuestion(qNo, qId) {
    // console.log(qNo, qId);
    return (dispatch, getState) => {
        let totalQuestions = getState().testInfo?.test?.length;
        if(qNo < 0 || qNo >=totalQuestions) return null;        
        dispatch(dispatchChangeQuestion(qNo));
        dispatch(timeSpend(qId))
    }
}


export function selectedAnswers(qId, answer) { 

    return (dispatch, getState) => {       
        let answers = getState().testInfo.selectedAnswers || [];
        
        let index;
        answers.map(x => {
            if(x.id === qId) {
                index = answers.indexOf(x);
            }           
        })
        if(index>=0) {
            answers[index].answer_option = answer;
        }else{
            answers = [...answers, {id: qId, answer_option: answer, status: 1}];            
        } 
        return dispatch(dispatchSelectedAnswers(answers));       
    }
}

export function getTest(testId, isPlannedTest, isTestSeries, isMaterialTest) {
   
    let endPoint = isPlannedTest ? "start_planned_test" : isTestSeries ? 'start_mock_test' : isMaterialTest ? 'startMaterialTest' : 'start_test';
    let data = isPlannedTest ? { event_id : testId} : isTestSeries ? { mock_test_id : testId } : isMaterialTest ? { material_test_id: testId } : { test_id : testId }

    // alert(JSON.stringify(isPlannedTest));

    // console.log(testId, isPlannedTest, endPoint, data);
    return dispatch => {
        dispatch(dispatchRequestTest(data));

        getUserToken().then(token => {           
           return axios({
                method: 'POST',
                url: `${baseUrl}/api/${endPoint}`,
                data,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })          
            .then(({data}) => {  
                if(data) {   
                    console.log(data,'test data');                
                    const { questions, duration = 12, test_id = null, passages} = data;              
                    if(questions && duration) {
                        dispatch(dispatchReceviedTest(questions, duration, test_id, data, passages));
                    }else{
                        dispatch(dispatchErrorTest({message: 'something went wrong...'}))
                    }
                }else{
                    dispatch(dispatchErrorTest({message: 'something went wrong...'}))
                }
            })
        })
        .catch(e => {
            dispatch(dispatchErrorTest(e));
        })
    }
}

export function markedQuestions(qId) {
 
    return (dispatch, getState) => {
        let markedQustions = getState().testInfo.questionsInfo || [];
        let index;

        markedQustions.map(q => {            
            if(q.id === qId) {
                return index = markedQustions.indexOf(q);
            }
        })

        if(index>=0) {
            markedQustions[index].marked=!markedQustions[index].marked;
        }else{
            markedQustions = [...markedQustions, {id:qId, marked:true}]
        }
        dispatch(dispatchMarkedQuestions(markedQustions));
    }
}











 

